import {
    LocalPushSchedule,
    CreateLocalPushScheduleRequest,
    UpdateLocalPushScheduleRequest,
} from '../types/localPush';
import { apiClient } from './axios';

export const localPushApi = {
    getAll: () =>
        apiClient.get<LocalPushSchedule[]>('/admin/local-push/schedules'),

    getById: (id: number) =>
        apiClient.get<LocalPushSchedule>(`/admin/local-push/schedules/${id}`),

    create: (data: CreateLocalPushScheduleRequest) =>
        apiClient.post<LocalPushSchedule>('/admin/local-push/schedules', data),

    update: (id: number, data: UpdateLocalPushScheduleRequest) =>
        apiClient.put<LocalPushSchedule>(`/admin/local-push/schedules/${id}`, data),

    delete: (id: number) =>
        apiClient.deleteNoData(`/admin/local-push/schedules/${id}`),
};
